export enum ConsoleUserRoleEnum {
    SUPER_ADMIN = 'SUPER_ADMIN',
    ADMIN = 'ADMIN',
    VIEWER = 'VIEWER',
}
